/**
 * Helpers for data uri features
 * @module data-uri
 */
import replace from 'lodash/replace'
import { ENCODING_BASE64 } from './encodings'

/**
 * Given a data uri the is base 64 encoded get the data portion of the string
 * @param {String} dataUri The data uri
 * @returns {String} The data portion of the uri
 */
export function getDataUriBase64Data (dataUri) {
  return replace(dataUri, /^.*base64,/, '')
}

/**
 * create a data uri string
 * @param {String} base64Data The data portion of the uri base64 encoded
 * @param {String} [mediaType] The media type of the data
 * @param {String} [encoding='base64'] The encoding of the data
 * @returns {String} A data uri
 */
export function createDataUri (base64Data, mediaType, encoding = ENCODING_BASE64) {
  let dataUri = 'data:'
  if (mediaType) {
    dataUri = `${dataUri}${mediaType}`
  }
  if (encoding) {
    dataUri = `${dataUri};${encoding}`
  }
  return `${dataUri},${base64Data}`
}

/**
 * Converts a dataUri string to a Blob
 * @param {String} str the DataUri we want to convert tto a Blob ex: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA..."
 * @returns {Blob} a Blob with the correct type based on the dataUri
 */
export function dataUriToBlob (dataUri) {
  const mimeType = dataUri.split(',')[0]?.split(';')[0]?.replace('data:', '') || ''
  const base64 = dataUri.split(',')[1]
  const byteString = atob(base64)
  const arrayBuffer = new ArrayBuffer(byteString.length)
  const uint8Array = new Uint8Array(arrayBuffer)
  for (let i = 0; i < byteString.length; i += 1) {
    uint8Array[i] = byteString.charCodeAt(i)
  }
  return new Blob([uint8Array], { type: mimeType })
}
